/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const _MealState = {
  id: null,
  name: '',
  unit_price: 0,
  sale_unit: ''
}

class MealState extends Record(_MealState) {
  mergeModel(model) {
    return this.merge(model)
  }
}

export { MealState }
